import { TabEntity } from 'src/entities/tab/TabEntity';

import type { TSerializedTab } from 'src/entities/workspace/types';

export const GROUPS = [
  {
    id: '1',
    color: '#219653',
    contrastColor: '#FFFFFF',
  },
  {
    id: '2',
    color: '#F2C94C',
    contrastColor: '#06152B',
  },
  {
    id: '3',
    color: '#FF6565',
    contrastColor: '#FFFFFF',
  },
  {
    id: '4',
    color: '#F2994A',
    contrastColor: '#06152B',
  },
  {
    id: '5',
    color: '#BD69FF',
    contrastColor: '#FFFFFF',
  },
  {
    id: '6',
    color: '#FEBBBA',
    contrastColor: '#06152B',
  },
  {
    id: '7',
    color: '#2D9CDB',
    contrastColor: '#FFFFFF',
  },
];

export function mapTabs(rawData: TSerializedTab[]): { tabs: TabEntity[]; activeKey?: string } {
  let activeKey = undefined;

  const tabs = rawData.map((rawTab) => {
    if (rawTab.isActive) {
      activeKey = rawTab.id;
    }

    return mapTab(rawTab);
  });

  return { tabs, activeKey };
}

export function mapTab(rawData: TSerializedTab): TabEntity {
  const groups = rawData.groups ?? GROUPS;

  const newTab = new TabEntity({
    name: rawData.name,
    id: rawData.id,
    templateId: rawData?.templateId,
    groups,
    layouts: rawData.layouts,
    rawWidgetsData: rawData.widgets,
    wellListPanelState: rawData.wellListPanelState,
  });

  return newTab;
}
